<template>
  <div
    v-for="(item, index) in items"
    :key="index"
    class="accordion"
  >
    <button
      @click="toggleItem(index)"
      class="accordion__btn"
      :aria-expanded="isOpen(index)"
      :aria-controls="`accordion-content-${index}`"
    >
      <div class="pr-4">
        {{ item.label }}
      </div>
      <div>
        <DefaultIconsChevronDown
          :class="{ 'rotate-180': isOpen(index) }"
        />
      </div>
    </button>

    <div
      :id="`accordion-content-${index}`"
      class="accordion__body"
      :class="{
        'max-h-96 opacity-100': isOpen(index),
        'max-h-0 opacity-0': !isOpen(index)
      }"
    >
      <div class="pb-4 text-sm" v-html="item.content">
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {type PropType, ref} from 'vue'

// Types
interface AccordionItem {
  label?: string
  content?: string
}

const props = defineProps({
  items: {type: Array as PropType<AccordionItem[]>, required: false},
  allowMultipleOpen: {type: Boolean, required: false, default: false},
})

// State
const openItems = ref<Set<number>>(new Set())

// Methods
const toggleItem = (itemIndex: number) => {
  const newOpenItems = new Set(openItems.value)

  if (props.allowMultipleOpen) {
    if (newOpenItems.has(itemIndex)) {
      newOpenItems.delete(itemIndex)
    } else {
      newOpenItems.add(itemIndex)
    }
  } else {
    if (newOpenItems.has(itemIndex)) {
      newOpenItems.clear()
    } else {
      newOpenItems.clear()
      newOpenItems.add(itemIndex)
    }
  }

  openItems.value = newOpenItems
}

const isOpen = (itemIndex: number): boolean => {
  return openItems.value.has(itemIndex)
}
</script>

<style scoped>
/* Additional custom styles if needed */
</style>